(function($) {

  tippy('.tooltip', {
    delay: 100,
    arrow: true,
    arrowType: 'round',
    size: 'large',
    duration: 200,
    animation: 'scale'
  });

})(jQuery);
